import React from 'react';
import { Input, Flex } from '@upsales/components';
import { get } from 'lodash';
import WidgetFieldSetting from './helpers/WidgetFieldSetting';
import {
	EditWidgetRowProps,
	WidgetDataSourceProps,
	WidgetRow
} from 'App/components/hooks/integrations/externalIntegrationTypes';
import UiWidgetRow, { EditUiWidgetRow } from './UiWidgetRow';
import { removeBracketsFromTag } from './UiWidgetHelpers';
import { useTranslation } from 'Components/Helpers/translate';

// Edit version
export const EditUiWidgetLoop = ({ row, onUpdate, dataSources }: EditWidgetRowProps) => {
	const dataTag = row.settings?.dataTag || '';
	const { t } = useTranslation();

	const handleChange = (field: string, value: any) => {
		onUpdate({
			...row,
			settings: {
				...row.settings,
				[field]: value
			}
		});
	};

	const onRowChange = (updatedRow: WidgetRow) => {
		onUpdate(updatedRow);
	};

	// Placeholder: In edit mode, we can't know the data array, so just show the tag input
	return (
		<Flex direction="column" gap="u2">
			<WidgetFieldSetting text={t('default.dataTag')}>
				<Input value={dataTag} onChange={e => handleChange('dataTag', e.target.value)} />
			</WidgetFieldSetting>
			<WidgetFieldSetting text={t('default.rows')} tooltip={t('default.loopIndexTooltip')}>
				<EditUiWidgetRow row={row} onUpdate={updatedRow => onRowChange(updatedRow)} dataSources={dataSources} />
			</WidgetFieldSetting>
		</Flex>
	);
};

// View version
const UiWidgetLoop: React.FC<WidgetDataSourceProps> = ({
	row,
	dataSources,
	widgetExternalId,
	widgetSettings,
	widgetType
}) => {
	const dataTag = row.settings?.dataTag || '';
	const array = get(dataSources, removeBracketsFromTag(dataTag), []);

	if (!Array.isArray(array)) {
		return null;
	}

	return (
		<Flex direction="column" gap="u2">
			{array.map((item, index) => (
				<UiWidgetRow
					key={`loop-${row.id}-${index}`}
					row={{
						...row,
						settings: { ...row.settings, index }
					}}
					widgetExternalId={widgetExternalId}
					dataSources={dataSources}
					widgetSettings={widgetSettings}
					widgetType={widgetType}
				/>
			))}
		</Flex>
	);
};

export default UiWidgetLoop;
